<template>
  <div id="navContainer">
    <div class="operations">
      <el-button type="primary" size="small" plain @click.stop="returnUpOneLevel" ><i class="el-icon-back" style="margin-right:3px"></i>返回上一级</el-button >
    </div>
    <div class="copy el-icon-copy-document" @click="copyPath">复制</div>
    <el-breadcrumb ref="breadDiv" separator="/">
      <el-breadcrumb-item v-for="(item, index) in navArr" :key="index" :last="index === navArr.length - 1 ? 'yes': 'no'" style="cursor: pointer" >
        <span :id="[item.folderId === folderName ? 'active1' : '']" :title="breadTitle(navArr, item)" style="width:100%;display:block;text-align:center" :class="{ellipsis: index !== navArr.length - 1}" @click="index !== navArr.length - 1 && clickBread(item)" >
          {{ item.folderName }}
        </span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="sort__wrapper" v-if="folderName !== 'recycle'" key="0">
      <el-dropdown>
        <el-tag> 
          {{ list[0].label }}
          <span class="text" :data-up="show==='descending'">{{ show === 'descending' ? '↓': '↑' }}</span>
        </el-tag>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item 
            v-for="(item, index) in list" 
            :key="index" 
            @click.native="zIndexBottom(item,index)">
            {{ item.label }}
            <span class="text" :data-up="show !=='descending'" v-if="index == 0"> {{ show !=='descending' ?  '↓': '↑' }}</span>
            <span class="text" v-else> ↑</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      list:[
        {label:"名称",id:"fileNameSort"},
        {label:"时间",id:"checkInDate"},
        {label:"类型",id:"fileSuffix"},
        {label:"大小",id:"size"}
      ],
      show:"ascending",
      obj:{},
      descending_png:require('@/commonAssets/projectMg/descending.png'),
      ascending_png:require('@/commonAssets/projectMg/ascending.png')
    };
  },
  computed: {
    ...mapState({
      navArr: state => state.XtDesign.navArr,
      currentNode: state => state.XtDesign.currentTreeNode,
    }),
    folderName() {
      if (this.currentNode.data) {
        return this.currentNode.data.folderId;
      }
    },
  },
  watch:{
    folderName(newValue, oldValue){
      if(oldValue!==newValue){
        this.show="ascending"
        this.list.forEach((item,index)=>{
          if(item.id === 'fileNameSort'){
            this.obj = item;
            this.list.splice(index,1)
            return;
          }
        })
         this.list.unshift( this.obj);
      }
    }
  },
  methods: {
    clickBread(item) {
      if (item.isSearch) {
        this.$store.dispatch("XtDesignUpdateSearchRow", { ...item });
      } else {
        this.$store.dispatch("XtDesignOpenNodeFolder", item);
      }
    },
    copyPath() {
      const path = this.navArr.map(item => item.folderName).join('/')
      this.$copyText(path).then((res) => {
        this.$message.success('链接复制成功！');
      });

    },
    breadTitle(breadArr, item) {
      const titleArr = [];
      for (let i = 0; i < breadArr.length; i++) {
        titleArr.push(breadArr[i].folderName);
        if (breadArr[i].folderID === item.folderID) {
          break;
        }
      }
      return titleArr.join("/");
    },
    async returnUpOneLevel() {
      if (this.navArr.length >= 2) {
        const lastObj = this.navArr[this.navArr.length - 2];
        if (lastObj.isSearch) {
          this.$store.dispatch("XtDesignUpdateSearchRow", lastObj);
        } else {
          this.$store.dispatch("XtDesignNavReturn");
        }
      }
    },
    zIndexBottom(item,index){
      const {swapArray,list} =this;
       if(index!=0){
         this.show="ascending"
        //首先判断当前元素需要上移几个位置,置底移动到数组的第一位
        var moveNum = index - 0;
        //循环出需要一个一个上移的次数
        for (var i = 0; i<moveNum; i++) {
          swapArray(list, index, index - 1);
          index--;
        }
      }else{
        if(this.show==="ascending") this.show="descending"
        else   this.show="ascending"
      }
      const data={prop:item.id,order:this.show}
      this.$store.dispatch("XtDesignSortData",data)
      this.$store.dispatch("docSortUpdateListOnly")
    },
    swapArray(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#navContainer
  width 100%
  height 65px
  // margin-top 10px
  display flex
  align-items center
  background-color #fff
  box-sizing border-box
  padding-right 25px
  .copy
    white-space nowrap
    margin-left 10px
    padding 5px
    color #4777E7
    cursor pointer
    user-select none
  .copy:hover
    color blue

  .operations
    min-width 80px
    display flex
    align-items center
    justify-content space-around
    padding-left 20px
    .el-button--primary.is-plain
      background:#fff
      border-color:#4777E7
      color: #4777E7
    .el-button--primary.is-plain:hover
      background:#E1EAFF
      border-color:#4777E7
      color: #4777E7
    img
      cursor pointer
  /deep/ .el-breadcrumb::-webkit-scrollbar
    width: 0px;
    height: 0px;

  /deep/ .el-breadcrumb
    white-space: nowrap
    overflow-x auto
    display flex
    width 80%
    height 40px
    align-items center
    margin-left 10px
    background-color #fff
    box-sizing border-box
    user-select: text

    .el-breadcrumb__item
      display flex
      padding 3px 0
    .el-breadcrumb__item[last="yes"]  span[role="presentation"]
      display none
    .el-breadcrumb__separator
      margin 0
      margin-right 6px
    .el-breadcrumb__inner
      display block
      max-width 100px
      span.ellipsis
        color #999
      span.ellipsis:hover
        color #409EFF
      span#active1
        color #323232
    .el-icon-arrow-right
      color #000
      margin 0
</style>
<style scoped lang="scss">
#navContainer{
  position: relative;
}
.sortDisplay{
  position: absolute;
  top: 20px;
  right: 50px;
  overflow: hidden;
  height: 36px;
  .sortItem{
    display: flex;
    align-items: center;
    height: 36px;
    line-height: 25px;
    width: 90px;
    padding: 1px 6px;
    color: #333;
    cursor: pointer;
    padding-left:24px
  }
  i{
    margin-left: 5px;
    color: #3873FE;
    font-size: 12px;
    font-weight: 600;
  }
  .sortItem:hover{
    background-color: rgba(85, 132, 255, 0.11);
  }
}
.sortDisplay:hover{
  position: absolute;
  top: 20px;
  right: 20px;
  width:90px;
  overflow: visible;
  height: 150px;
  background-color:#fff;
  z-index: 100000;
  border: 1px solid #D4D9EC;
  box-shadow: 0 4px 4x 0 rgba(46, 91, 255,0.1);
}
span.text {
  // color: #fff;
  padding: 2px;
  color: rgba(47, 53, 237, 0.874);
  &[data-up="true"] {
    color: rgba(231, 41, 85, 0.942);
  }
}
</style>
